/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ex_NoteInputs */

const en_to_yaml_ex_note = /** @type {(inputs: To_Yaml_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the values that a YAML reader could misread are quoted. Seoul is written bare because no reader would turn it into anything else.`)
};

const ko_to_yaml_ex_note = /** @type {(inputs: To_Yaml_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML 리더가 잘못 읽을 수 있는 값만 인용됩니다. Seoul은 어떤 리더도 다른 것으로 바꾸지 않으므로 그대로 작성됩니다.`)
};

const ja_to_yaml_ex_note = /** @type {(inputs: To_Yaml_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML リーダが読み違えうる値だけが引用されます。Seoul はどのリーダもほかのものに変えないので裸で書かれます。`)
};

/**
* | output |
* | --- |
* | "Only the values that a YAML reader could misread are quoted. Seoul is written bare because no reader would turn it into anything else." |
*
* @param {To_Yaml_Ex_NoteInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ex_note = /** @type {((inputs?: To_Yaml_Ex_NoteInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ex_NoteInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ex_note(inputs)
	if (locale === "ko") return ko_to_yaml_ex_note(inputs)
	return ja_to_yaml_ex_note(inputs)
});